module.exports = __webpack_public_path__ + "static/media/slide-patients.103939d3.svg";